import React, { useState } from "react";
import { api, Banner, Button } from "./ui.tsx";
export function PushSettings() {
  const [message, setMessage] = useState(""),
    [busy, setBusy] = useState(false);
  const supported =
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window &&
    window.isSecureContext;
  async function change(enable: boolean) {
    setBusy(true);
    setMessage("");
    try {
      if (!supported)
        throw Error(
          "Este navegador não oferece notificações neste modo. No iPhone, adicione o site à Tela de Início e abra por lá.",
        );
      if (enable) {
        // Browser permission remains an explicit user's button action.
        if ((await Notification.requestPermission()) !== "granted")
          throw Error(
            "Permissão não concedida. Você pode continuar consultando os avisos dentro do sistema.",
          );
        const { publicKey } = await api<{ publicKey: string }>("/push/key");
        const reg =
          await navigator.serviceWorker.register("/service-worker.js");
        await navigator.serviceWorker.ready;
        let subscription = await reg.pushManager.getSubscription();
        if (!subscription) {
          const raw = atob(publicKey.replace(/-/g, "+").replace(/_/g, "/"));
          subscription = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: Uint8Array.from(raw, (c) => c.charCodeAt(0)),
          });
        }
        try {
          const value = subscription.toJSON();
          await api("/push/subscriptions", "POST", {
            endpoint: value.endpoint,
            keys: value.keys,
          });
        } catch (error) {
          await subscription.unsubscribe();
          throw error;
        }
        setMessage(
          "Notificações ativadas neste aparelho durante esta sessão. Ao entrar novamente, ative-as se necessário.",
        );
      } else {
        await api("/push/subscriptions", "DELETE");
        const reg =
          await navigator.serviceWorker.getRegistration("/service-worker.js");
        await (await reg?.pushManager.getSubscription())?.unsubscribe();
        setMessage("Notificações desativadas neste aparelho.");
      }
    } catch (e) {
      setMessage((e as Error).message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <section className="progress-card">
      <h2>Notificações no aparelho</h2>
      <p>
        Receba um aviso discreto, sem dados de cidadãos na tela bloqueada. Os
        avisos continuam disponíveis dentro do sistema.
      </p>
      {!supported && (
        <p>
          No iPhone, abra o site adicionado à Tela de Início. A disponibilidade
          depende do navegador.
        </p>
      )}
      <Button busy={busy} onClick={() => void change(true)}>
        Ativar neste aparelho
      </Button>{" "}
      <Button busy={busy} onClick={() => void change(false)}>
        Desativar
      </Button>
      {message && <Banner>{message}</Banner>}
    </section>
  );
}
